import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Tabs from "./components/Tabs";
import { LogisticAction } from "redux/actions";
import HomeTab from "logistic-integrations/components/HomeTab";

const Slider = ({ order, fetchOrderDetailsByID }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { sliderModal } = useSelector((state) => state.LogisticReducer);

  return (
    <HomeTab
      {...{
        order,
        fetchOrderDetailsByID,
        title: t("Delivery Using Slider"),
        isOpen: sliderModal,
        onClose: () => {
          dispatch(LogisticAction.toggleSliderModal(false));
        },
      }}
    >
      <Tabs
        {...{ order, fetchOrderDetailsByID }}
        setOpen={() => {
          dispatch(LogisticAction.toggleSliderModal(false));
        }}
      />
    </HomeTab>
  );
};

export default Slider;
